// extracted by mini-css-extract-plugin
export default {"header":"header_header__PriWN","group":"header_group__0ANgd","avatar":"header_avatar__Vydt-"};